var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M16 22a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z",
    opacity: 1,
    "data-original": "#6cc396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M17 30h-2a3 3 0 0 1-3-3v-.753a14.732 14.732 0 0 1-.416-.175l-.534.534a3 3 0 0 1-4.242 0l-1.414-1.414a3 3 0 0 1 0-4.242l.534-.534A14.732 14.732 0 0 1 5.753 20H5a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h.753c.056-.139.114-.277.175-.416l-.534-.534a3 3 0 0 1 0-4.242l1.414-1.414a3 3 0 0 1 4.242 0l.534.534c.139-.061.277-.119.416-.175V5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v.753c.139.056.277.114.416.175l.534-.534a3 3 0 0 1 4.242 0l1.414 1.414a3 3 0 0 1 0 4.242l-.534.534c.061.139.119.277.175.416H27a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-.753c-.056.139-.114.277-.175.416l.534.534a3 3 0 0 1 0 4.242l-1.414 1.414a3 3 0 0 1-4.242 0l-.534-.534c-.139.061-.277.119-.416.175V27a3 3 0 0 1-3 3zm-5.62-6.137a.994.994 0 0 1 .463.114 8.934 8.934 0 0 0 1.457.61 1 1 0 0 1 .7.954V27a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.459a1 1 0 0 1 .7-.954 8.934 8.934 0 0 0 1.457-.61 1 1 0 0 1 1.171.179l1.036 1.036a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-1.036-1.036a1 1 0 0 1-.179-1.171 8.934 8.934 0 0 0 .61-1.457 1 1 0 0 1 .954-.7H27a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1.459a1 1 0 0 1-.954-.7 8.934 8.934 0 0 0-.61-1.457 1 1 0 0 1 .179-1.171l1.036-1.036a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-1.036 1.036a1 1 0 0 1-1.171.179 8.934 8.934 0 0 0-1.457-.61 1 1 0 0 1-.7-.954V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1.459a1 1 0 0 1-.7.954 8.934 8.934 0 0 0-1.457.61 1 1 0 0 1-1.171-.179L9.636 6.808a1 1 0 0 0-1.414 0L6.808 8.222a1 1 0 0 0 0 1.414l1.036 1.036a1 1 0 0 1 .179 1.171 8.934 8.934 0 0 0-.61 1.457 1 1 0 0 1-.954.7H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1.459a1 1 0 0 1 .954.7 8.934 8.934 0 0 0 .61 1.457 1 1 0 0 1-.179 1.171l-1.036 1.036a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l1.036-1.036a1 1 0 0 1 .708-.293z",
    opacity: 1,
    "data-original": "#13281a",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteSettingIcon);
export default __webpack_public_path__ + "static/media/site-setting-icon.60222d6c1246bdc4f962e8fa5e2992bd.svg";
export { ForwardRef as ReactComponent };